import { render, staticRenderFns } from "./TableChart.vue?vue&type=template&id=69671dda&scoped=true&"
import script from "./TableChart.vue?vue&type=script&lang=js&"
export * from "./TableChart.vue?vue&type=script&lang=js&"
import style0 from "./TableChart.vue?vue&type=style&index=0&id=69671dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69671dda",
  null
  
)

export default component.exports